import { css } from "lit";
import componentStyles from "../../styles/component.styles";
export default css `
    ${componentStyles}
    :host {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        box-sizing: border-box;
    }

    /* Theme variation */
    :host([theme~='margin']) {
        margin: 1em;
    }

    :host([theme~='padding']) {
        padding: 1em;
    }

    :host([theme~='spacing']) {
        gap: 1em;
    }
`;
//# sourceMappingURL=vertical-layout.styles.js.map